import {GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import styled, {css} from 'styled-components'

export const StyledTeamMemberGridItem = styled(GridItem)(
    ({theme: {spacing}}) => css`
        overflow: hidden;
        padding: ${spacing /
        4}px; // we need to add padding to the grid item to avoid the overflow of the avatar borders
    `
)
